import React from 'react';
import { connect } from 'react-redux';
import MemberListItem from './MemberListItem';

export const MemberList = (props) => (
  <div className='content-container'>
  <div className='list-header'>
  <div className='show-for-mobile'>Members</div>
  <div className='show-for-desktop'>Member</div>
  <div className='show-for-desktop'>Relation</div>
  </div>
    <div className='list-body'>
    {
      props.members.length === 0 ? (
        <div className='list-item list-item--message'>
        <span>No members</span>
        </div>
      ) : (
          props.members.map((member) => {
            return <MemberListItem key={member.id} {...member} />;
          })
        )
    }
    </div>
  </div>
);

const mapStateToProps = (state) => {
  return {
    members: state.members
  };
};

export default connect(mapStateToProps)(MemberList);



// WEBPACK FOOTER //
// ./src/components/MemberList.js